import React from "react";
import * as echarts from "echarts";
import moment from "moment";
import download from "./downloadCSV.jpg";
import close from "../../minimise_button.png";



export default class CChart extends React.Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef(); // Ref to hold the chart DOM element
  }

  componentDidMount() {
    this.initChart(); // Initialize the chart when the component is mounted
  }

  componentDidUpdate(prevProps) {
    // If chart options or data change, re-render the chart
    if (prevProps.seriesData !== this.props.seriesData) {
      this.updateChart();
    }
  }

  initChart() {
    const chart = echarts.init(this.chartRef.current);
    const options = this.getChartOptions();
    chart.setOption(options);
    this.chartInstance = chart; // Store the instance for later use
  }

  updateChart() {
    if (this.chartInstance) {
      const options = this.getChartOptions();
      this.chartInstance.setOption(options);
    }
  }
  exportToCSV = () => {
    const { seriesData, title } = this.props;
  
    // Convert data to CSV format
    let csvContent = `"Date",${this.props.excel} \n`;
   

    
    seriesData.forEach(([timestamp, value]) => {
      let prefix;
    
       
      
     
        prefix = moment(timestamp).format("DD MMM YYYY");
      
      const formattedValue = value !== null ? value : 'Cloud';
      csvContent += `${prefix},${formattedValue}\n`;
    });
  
    // Create a Blob containing the CSV data
    const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });

  
    // Create a link element and trigger a download
    const a = document.createElement('a');
    a.href = URL.createObjectURL(csvBlob);
    a.download = `${this.props.title.replace(/\s/g , "-") }.csv`;
    a.click();
  };
  
  getChartOptions() {
    return {
      title: {
        text: this.props.title,
        left: "center",
        top:"9%",
        textStyle: {
          fontSize: 14,
          fontWeight: "bold",
          color: "#263238",
        },
      },
      dataZoom: [
        {
          type: 'inside',
          start: 0,
          end: 100,
        },
      ],
      toolbox: {
        show: true,
        feature: {
        
          magicType: {
            type: ["bar", "line"],
            title: {
              line: "Line Chart",
              bar: "Bar Chart",
            },
          },
          restore: {
            title: "Restore",
          },
          saveAsImage: {
            type: ["png", "svg"],
            title: "Save Chart",
            name: this.props.title.replace(/\s/g , "-"),
          },
          myExportCSV: {  // Custom CSV button
            show: true,
            title: "Export to CSV",
            icon: `image://${download}`,  // You can replace this with the path to your custom icon
            onclick: this.exportToCSV,
          },
          myClose: {
            show: true,
            title: "Minimize",
            icon: `image://${close}`,
            onclick: this.props.toggleVisibleGraphPanel,
          },
        
        },
    
      },
    
      tooltip: {
        trigger: "axis",
        formatter: (params) => {
          const { data } = params[0];
          return `Date: ${moment(data[0]).format("DD MMM YYYY")}<br>${this.props.name}: ${data[1]}${this.props.units}`;
        },
        backgroundColor: "#333",
        textStyle: {
          color: "#fff",
        },
      },
      grid: {
        left: "5%",
        right: "5%",
        bottom: "5%",
        containLabel: true,
      },
      xAxis: {
        type: "time",
        name:"Date",
        nameGap: 20,
        nameTextStyle:{
          color:"#000000",
          fontWeight:"bold",
        },
        nameLocation: "middle",
        axisLabel: {
          formatter: (value) =>
            window.innerWidth > 1000
              ? moment(new Date(value)).format("DD MMM YYYY")
              : moment(new Date(value)).format("MMM YYYY"),


        },
      },
      yAxis: {
        type: "value",
        name:this.props.yAxisTitle,
        nameTextStyle:{
          color:"#000000",
          fontWeight:"bold",
        },
        nameGap: 50,
          nameLocation: "middle",
        min: 0,
        max: this.props.maxvalue
          ? this.props.maxvalue + this.props.maxvalue / 5
          : 100,
        axisLabel: {
          formatter: (value) => value.toFixed(0),
        },
      },
      series: [
        {
          name: this.props.name,
          type: this.props.type,
          data: this.props.seriesData,
          symbol: "none",
          lineStyle: {
            width: 2,
            color: "#26a0fc",
          },
          markLine: this.props.maxvalue && this.props.maxdate
          ? {
              data: [
                {
                  yAxis: this.props.maxvalue,
                  label: {
                    formatter: `Maximum Value (${Number(
                      this.props.maxvalue
                    ).toLocaleString("en-IN")} km²) on ${moment(
                      this.props.maxdate
                    ).format("DD MMM YYYY")}`,
                    position: "insideEndTop",
                  },
                  lineStyle: {
                    color: "#26a0fc",
                    type: "dashed",
                  },
                },
              ],
            }
          : undefined,
        
        },
      ],
    };
  }

  render() {

    console.log("this.props.width",this.props.width,this.props.height)
    return (
      <div>
        <div
          ref={this.chartRef}
          style={{ width: this.props.width, height: this.props.height }} // Adjust chart container size
        ></div>
      </div>
    );
  }
}
